import { ROOT_ID } from './constants';

export const getFolderState = (
	state,
	currentDirectoryType,
	folderUuid = ROOT_ID
) => {
	return state.directory[currentDirectoryType].foldersById[folderUuid];
};

export const getSearchQuery = (state, stateId) => {
	return state.directory[stateId]?.search?.query;
};

export const getMoveSideState = (state, stateId) => {
	return state.directory[stateId];
};

export const getOrderBy = (state, stateId) => {
	return state.directory[stateId].orderBy;
};

export const getFilterBy = (state, stateId) => {
	return state.directory[stateId].filterBy;
};
